import React from 'react'
import { Plus, RefreshCcw, Search, X } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'

export function BlogToolbar({ searchQuery, onSearchChange, onClearSearch, onRefresh, onNewPost, statusFilter, onStatusFilterChange }) {
  return (
    <div className="flex items-center gap-2">
      <div className="relative flex items-center">
        <Search className="absolute left-2.5 h-4 w-4 text-muted-foreground" />
        <input
          value={searchQuery}
          placeholder="Search posts"
          onChange={(event) => onSearchChange(event.target.value)}
          className="h-9 w-56 rounded-md border border-input bg-background pl-8 pr-8 text-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        />
        {searchQuery ? (
          <button
            type="button"
            aria-label="Clear search"
            onClick={onClearSearch}
            className="absolute right-2.5 text-muted-foreground hover:text-foreground"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        ) : null}
      </div>
      <Select value={statusFilter} onValueChange={onStatusFilterChange}>
        <SelectTrigger className="h-9 w-36">
          <SelectValue placeholder="Status" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All statuses</SelectItem>
          <SelectItem value="published">Published</SelectItem>
          <SelectItem value="draft">Draft</SelectItem>
          <SelectItem value="archived">Archived</SelectItem>
        </SelectContent>
      </Select>
      <Button type="button" variant="outline" size="sm" onClick={onRefresh}>
        <RefreshCcw className="mr-1.5 h-4 w-4" /> Refresh
      </Button>
      <Button type="button" size="sm" onClick={onNewPost}>
        <Plus className="mr-1.5 h-4 w-4" /> New post
      </Button>
    </div>
  )
}
